import type { AccountMappingPaymentLocation } from "api/models";

export function formatPaymentLocationPrimaryLabel(location: {
  location_name?: string;
  payment_location?: string;
}): string {
  const locationName = location.location_name?.trim() || "";
  const paymentLocation = location.payment_location?.trim() || "";

  if (locationName && paymentLocation) {
    return `${locationName} (${paymentLocation})`;
  }

  return locationName || paymentLocation;
}

export function formatPaymentLocationLabel(location: {
  shipper_name?: string;
  payment_location?: string;
  location_name?: string;
}): string {
  const base = formatPaymentLocationPrimaryLabel(location);
  const shipperName = location.shipper_name?.trim() || "";

  if (!base) {
    return shipperName;
  }

  return shipperName ? `${base} - ${shipperName}` : base;
}

export function toPaymentLocationOptions(locations: AccountMappingPaymentLocation[] | undefined) {
  return (locations || []).map((location) => ({
    label: formatPaymentLocationPrimaryLabel(location),
    value: location.payment_location,
    supportingText: location.shipper_name?.trim() || undefined,
  }));
}
